"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmotionCacheProvider = void 0;
var _cache = _interopRequireDefault(require("@emotion/cache"));
var _react = require("@emotion/react");
var _react2 = require("react");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Provides an Emotion cache context for styling components.
 *
 * This component wraps its children with Emotion's CacheProvider, allowing
 * for consistent styling throughout the component tree. It either uses a
 * provided cache or creates a new one with specified settings.
 *
 * @param children - Child components to be wrapped
 * @param cacheKey - Required key for the Emotion cache
 * @param cache - Optional pre-configured Emotion cache instance
 *
 * @returns CacheProvider component with the specified or default cache
 *
 * @example
 * ```tsx
 * <EmotionCacheProvider cacheKey={EMOTION_CACHE_KEY}>
 *   <ThemeProvider>
 *     <App />
 *   </ThemeProvider>
 * </EmotionCacheProvider>
 * ```
 */ var EmotionCacheProvider = function(param) {
    var children = param.children, cacheKey = param.cacheKey, cache = param.cache;
    var emotionCache = (0, _react2.useMemo)(function() {
        return cache !== null && cache !== void 0 ? cache : (0, _cache.default)({
            prepend: true,
            key: cacheKey
        });
    }, [
        cacheKey,
        cache
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.CacheProvider, {
        value: emotionCache,
        children: children
    });
};
exports.EmotionCacheProvider = EmotionCacheProvider; //# sourceMappingURL=EmotionCacheProvider.js.map
